<template>
    <div class="permisson-forbidden-page-container">
        <div class="icon-wrap">
            <img src="./assets/images/icon-no-permit.gif" />
        </div>
        <div class="info-wrap">
            <p>无访问权限，请联系管理员开通</p>
            <div class="action">
                <a :href="urlHomepage">
                    <i class="icon icon-home"></i>回到首页
                </a>
                <a href="javascript:" @click="closePage" id="linkLogout">
                    <i class="icon click-logout-icon"></i>退出登录
                </a>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: "PermissonForbidden",
    data() {
        return {
            urlHomepage: "/mng/account/index"
        }
    },
    methods: {
        closePage() {
            window.QD_ADMIN_COMMON?.logout();
        }
    }
};
</script>
<style lang="less">
.permisson-forbidden-page-container {
    display: flex;
    width: 100%;
    height: calc(100vh - 120px);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .icon-wrap {
        position: relative;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .info-wrap {
        padding-top: 10px;
        padding-bottom: 30px;
        height: 290px;
        width: 100%;
        p {
            font-size: 30px;
            line-height: 1.7;
            text-align: center;
        }
        .action {
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon{
                display: inline-block;
                vertical-align: -5px;
                margin-right: 3px;
            }
            .icon-home{
                background-image: url(./assets/images/icons.png);
                width: 20px;
                height: 20px;
                background-position: 0 -20px;
            }
            .click-logout-icon{
                background-image: url(./assets/images/icons.png);
                width: 20px;
                height: 20px;
                background-position: -20px 0;
            }
            a {
                margin: 0 25px;
                font-size: 14px;
                line-height: 20px;
                height: 20px;
                color: #0067ed;
                text-decoration: none;
                display: flex;
                align-items: center;
            }
        }
    }
}
</style>
